export const doubleHeaderThreshold = 1130;
export const hasDoubleHeader = () => window.innerWidth <= 1130;
